module.exports = __webpack_public_path__ + "img/people-dress.f3ae5f97.svg";